import { Loadable } from 'foundations-components/transitional/utils/Loadable';
function DeferredSectionLoading() {
  return null;
}
export function createDeferredLoadable(typedLoader) {
  return Loadable({
    typedLoader,
    LoadingComponent: DeferredSectionLoading,
    delay: 0
  });
}